import '../styles/Navbar.css';
import React, { useEffect, useState } from 'react';

const PAGES = [
  { name: 'Landing', href: '/' },
  { name: 'Sign Up', href: '/sign-up' },
  { name: 'Login', href: '/login' },
  { name: 'Dashboard', href: '/dashboard' },
  { name: 'Transfer', href: '/transfer' },
  { name: 'Transfer History', href: '/transfer-history' },
  { name: 'Operations', href: '/operations' },
];

function resolveActivePath(activePage) {
  const provided = typeof activePage === 'string' ? activePage.trim() : '';
  if (provided) {
    const byPath = PAGES.find((p) => p.href === provided);
    if (byPath) return byPath.href;
    const byName = PAGES.find(
      (p) => p.name.toLowerCase() === provided.toLowerCase()
    );
    if (byName) return byName.href;
    return '';
  }
  if (typeof window !== 'undefined' && window.location && window.location.pathname) {
    return window.location.pathname;
  }
  return '';
}

export default function Navbar({ activePage }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const activePath = resolveActivePath(activePage);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const onKeyDown = (event) => {
      if (event.key === 'Escape') setMenuOpen(false);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [menuOpen]);

  const isActive = (href) => href === activePath;

  return (
    <header className="nb-root">
      <div className="nb-bar">
        <a className="nb-brand" href="/" aria-label="Online Banking — home">
          <span className="nb-wordmark">Online Banking</span>
          <span className="nb-brand-mark">Online Banking System</span>
        </a>

        <nav aria-label="Primary">
          <ul className="nb-links">
            {PAGES.map((page) => (
              <li key={page.href}>
                <a
                  className={
                    isActive(page.href) ? 'nb-link is-active' : 'nb-link'
                  }
                  href={page.href}
                  aria-current={isActive(page.href) ? 'page' : undefined}
                >
                  {page.name}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <button
          type="button"
          className="nb-toggle"
          aria-expanded={menuOpen}
          aria-controls="nb-drawer"
          aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span className="nb-toggle-bar" aria-hidden="true"></span>
          <span className="nb-toggle-bar" aria-hidden="true"></span>
          <span className="nb-toggle-bar" aria-hidden="true"></span>
        </button>
      </div>

      <div
        className={menuOpen ? 'nb-scrim is-open' : 'nb-scrim'}
        onClick={() => setMenuOpen(false)}
        aria-hidden="true"
      ></div>

      <ul
        id="nb-drawer"
        className={menuOpen ? 'nb-drawer is-open' : 'nb-drawer'}
        aria-label="Primary"
      >
        {PAGES.map((page) => (
          <li key={page.href}>
            <a
              className={isActive(page.href) ? 'nb-link is-active' : 'nb-link'}
              href={page.href}
              aria-current={isActive(page.href) ? 'page' : undefined}
              onClick={() => setMenuOpen(false)}
            >
              {page.name}
            </a>
          </li>
        ))}
      </ul>
    </header>
  );
}